"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphPropertiesHistoryItem = exports.ParagraphKeepWithNextHistoryItem = exports.ParagraphDivIdHistoryItem = exports.ParagraphWidowOrphanControlHistoryItem = exports.ParagraphSuppressLineNumbersHistoryItem = exports.ParagraphSuppressHyphenationHistoryItem = exports.ParagraphSpacingBeforeHistoryItem = exports.ParagraphSpacingAfterHistoryItem = exports.ParagraphRightIndentHistoryItem = exports.ParagraphPageBreakBeforeHistoryItem = exports.ParagraphOutlineLevelHistoryItem = exports.ParagraphLineSpacingTypeHistoryItem = exports.ParagraphLineSpacingHistoryItem = exports.ParagraphLeftIndentHistoryItem = exports.ParagraphKeepLinesTogetherHistoryItem = exports.ParagraphFirstLineIndentTypeHistoryItem = exports.ParagraphFirstLineIndentHistoryItem = exports.ParagraphBeforeAutoSpacingHistoryItem = exports.ParagraphShadingInfoIndexHistoryItem = exports.ParagraphAfterAutoSpacingHistoryItem = exports.ParagraphRightToLeftHistoryItem = exports.ParagraphContextualSpacingHistoryItem = exports.ParagraphAlignmentHistoryItem = exports.ParagraphPropertiesHistoryItemBase = exports.DeleteTabAtParagraphHistoryItem = exports.InsertTabToParagraphHistoryItem = exports.TabHistoryItemBase = exports.ParagraphUseValueHistoryItem = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var history_item_1 = require("../base/history-item");
var interval_based_history_item_1 = require("../base/interval-based-history-item");
var ParagraphUseValueHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphUseValueHistoryItem, _super);
    function ParagraphUseValueHistoryItem(modelManipulator, subDocInterval, newValue) {
        var _this = _super.call(this, modelManipulator, subDocInterval) || this;
        _this.newValue = newValue;
        return _this;
    }
    ParagraphUseValueHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.paragraphProperties.useValue.setValue(this.boundSubDocument, this.interval, this.newValue);
    };
    ParagraphUseValueHistoryItem.prototype.undo = function () {
        this.modelManipulator.paragraphProperties.useValue.restoreValue(this.boundSubDocument, this.oldState);
    };
    return ParagraphUseValueHistoryItem;
}(interval_based_history_item_1.IntervalBasedHistoryItem));
exports.ParagraphUseValueHistoryItem = ParagraphUseValueHistoryItem;
var TabHistoryItemBase = (function (_super) {
    tslib_1.__extends(TabHistoryItemBase, _super);
    function TabHistoryItemBase(modelManipulator, subDocInterval, tabInfo) {
        var _this = _super.call(this, modelManipulator, subDocInterval) || this;
        _this.tabInfo = tabInfo;
        return _this;
    }
    return TabHistoryItemBase;
}(interval_based_history_item_1.IntervalBasedHistoryItem));
exports.TabHistoryItemBase = TabHistoryItemBase;
var InsertTabToParagraphHistoryItem = (function (_super) {
    tslib_1.__extends(InsertTabToParagraphHistoryItem, _super);
    function InsertTabToParagraphHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InsertTabToParagraphHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.tab.insertTabToParagraph(this.boundSubDocument, this.interval, this.tabInfo);
    };
    InsertTabToParagraphHistoryItem.prototype.undo = function () {
        this.modelManipulator.tab.restoreInsertedTabToParagraph(this.boundSubDocument, this.oldState);
    };
    return InsertTabToParagraphHistoryItem;
}(TabHistoryItemBase));
exports.InsertTabToParagraphHistoryItem = InsertTabToParagraphHistoryItem;
var DeleteTabAtParagraphHistoryItem = (function (_super) {
    tslib_1.__extends(DeleteTabAtParagraphHistoryItem, _super);
    function DeleteTabAtParagraphHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteTabAtParagraphHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.tab.deleteTabAtParagraph(this.boundSubDocument, this.interval, this.tabInfo);
    };
    DeleteTabAtParagraphHistoryItem.prototype.undo = function () {
        this.modelManipulator.tab.restoreDeletedTabAtParagraph(this.boundSubDocument, this.oldState);
    };
    return DeleteTabAtParagraphHistoryItem;
}(TabHistoryItemBase));
exports.DeleteTabAtParagraphHistoryItem = DeleteTabAtParagraphHistoryItem;
var ParagraphPropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(ParagraphPropertiesHistoryItemBase, _super);
    function ParagraphPropertiesHistoryItemBase(modelManipulator, subDocInterval, newValue, newUse) {
        var _this = _super.call(this, modelManipulator, subDocInterval) || this;
        _this.newValue = newValue;
        _this.newUse = newUse;
        return _this;
    }
    ParagraphPropertiesHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getPropertiesManipulator().setValue(this.boundSubDocument, this.interval, this.newValue, this.newUse);
    };
    ParagraphPropertiesHistoryItemBase.prototype.undo = function () {
        this.getPropertiesManipulator().restoreValue(this.boundSubDocument, this.oldState);
    };
    ParagraphPropertiesHistoryItemBase.prototype.getPropertiesManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return ParagraphPropertiesHistoryItemBase;
}(interval_based_history_item_1.IntervalBasedHistoryItem));
exports.ParagraphPropertiesHistoryItemBase = ParagraphPropertiesHistoryItemBase;
var ParagraphAlignmentHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphAlignmentHistoryItem, _super);
    function ParagraphAlignmentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphAlignmentHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.align;
    };
    return ParagraphAlignmentHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphAlignmentHistoryItem = ParagraphAlignmentHistoryItem;
var ParagraphContextualSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphContextualSpacingHistoryItem, _super);
    function ParagraphContextualSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphContextualSpacingHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.contextualSpacing;
    };
    return ParagraphContextualSpacingHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphContextualSpacingHistoryItem = ParagraphContextualSpacingHistoryItem;
var ParagraphRightToLeftHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphRightToLeftHistoryItem, _super);
    function ParagraphRightToLeftHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphRightToLeftHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.rightToLeft;
    };
    return ParagraphRightToLeftHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphRightToLeftHistoryItem = ParagraphRightToLeftHistoryItem;
var ParagraphAfterAutoSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphAfterAutoSpacingHistoryItem, _super);
    function ParagraphAfterAutoSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphAfterAutoSpacingHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.afterAutoSpacing;
    };
    return ParagraphAfterAutoSpacingHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphAfterAutoSpacingHistoryItem = ParagraphAfterAutoSpacingHistoryItem;
var ParagraphShadingInfoIndexHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphShadingInfoIndexHistoryItem, _super);
    function ParagraphShadingInfoIndexHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphShadingInfoIndexHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.shadingInfo;
    };
    return ParagraphShadingInfoIndexHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphShadingInfoIndexHistoryItem = ParagraphShadingInfoIndexHistoryItem;
var ParagraphBeforeAutoSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphBeforeAutoSpacingHistoryItem, _super);
    function ParagraphBeforeAutoSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphBeforeAutoSpacingHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.beforeAutoSpacing;
    };
    return ParagraphBeforeAutoSpacingHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphBeforeAutoSpacingHistoryItem = ParagraphBeforeAutoSpacingHistoryItem;
var ParagraphFirstLineIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphFirstLineIndentHistoryItem, _super);
    function ParagraphFirstLineIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphFirstLineIndentHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.firstLineIndent;
    };
    return ParagraphFirstLineIndentHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphFirstLineIndentHistoryItem = ParagraphFirstLineIndentHistoryItem;
var ParagraphFirstLineIndentTypeHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphFirstLineIndentTypeHistoryItem, _super);
    function ParagraphFirstLineIndentTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphFirstLineIndentTypeHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.firstLineIndentType;
    };
    return ParagraphFirstLineIndentTypeHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphFirstLineIndentTypeHistoryItem = ParagraphFirstLineIndentTypeHistoryItem;
var ParagraphKeepLinesTogetherHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphKeepLinesTogetherHistoryItem, _super);
    function ParagraphKeepLinesTogetherHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphKeepLinesTogetherHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.keepLinesTogether;
    };
    return ParagraphKeepLinesTogetherHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphKeepLinesTogetherHistoryItem = ParagraphKeepLinesTogetherHistoryItem;
var ParagraphLeftIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphLeftIndentHistoryItem, _super);
    function ParagraphLeftIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphLeftIndentHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.leftIndent;
    };
    return ParagraphLeftIndentHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphLeftIndentHistoryItem = ParagraphLeftIndentHistoryItem;
var ParagraphLineSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphLineSpacingHistoryItem, _super);
    function ParagraphLineSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphLineSpacingHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.lineSpacing;
    };
    return ParagraphLineSpacingHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphLineSpacingHistoryItem = ParagraphLineSpacingHistoryItem;
var ParagraphLineSpacingTypeHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphLineSpacingTypeHistoryItem, _super);
    function ParagraphLineSpacingTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphLineSpacingTypeHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.lineSpacingType;
    };
    return ParagraphLineSpacingTypeHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphLineSpacingTypeHistoryItem = ParagraphLineSpacingTypeHistoryItem;
var ParagraphOutlineLevelHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphOutlineLevelHistoryItem, _super);
    function ParagraphOutlineLevelHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphOutlineLevelHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.outlineLevel;
    };
    return ParagraphOutlineLevelHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphOutlineLevelHistoryItem = ParagraphOutlineLevelHistoryItem;
var ParagraphPageBreakBeforeHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphPageBreakBeforeHistoryItem, _super);
    function ParagraphPageBreakBeforeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphPageBreakBeforeHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.pageBreakBefore;
    };
    return ParagraphPageBreakBeforeHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphPageBreakBeforeHistoryItem = ParagraphPageBreakBeforeHistoryItem;
var ParagraphRightIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphRightIndentHistoryItem, _super);
    function ParagraphRightIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphRightIndentHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.rightIndent;
    };
    return ParagraphRightIndentHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphRightIndentHistoryItem = ParagraphRightIndentHistoryItem;
var ParagraphSpacingAfterHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphSpacingAfterHistoryItem, _super);
    function ParagraphSpacingAfterHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphSpacingAfterHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.spacingAfter;
    };
    return ParagraphSpacingAfterHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphSpacingAfterHistoryItem = ParagraphSpacingAfterHistoryItem;
var ParagraphSpacingBeforeHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphSpacingBeforeHistoryItem, _super);
    function ParagraphSpacingBeforeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphSpacingBeforeHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.spacingBefore;
    };
    return ParagraphSpacingBeforeHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphSpacingBeforeHistoryItem = ParagraphSpacingBeforeHistoryItem;
var ParagraphSuppressHyphenationHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphSuppressHyphenationHistoryItem, _super);
    function ParagraphSuppressHyphenationHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphSuppressHyphenationHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.suppressHyphenation;
    };
    return ParagraphSuppressHyphenationHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphSuppressHyphenationHistoryItem = ParagraphSuppressHyphenationHistoryItem;
var ParagraphSuppressLineNumbersHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphSuppressLineNumbersHistoryItem, _super);
    function ParagraphSuppressLineNumbersHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphSuppressLineNumbersHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.suppressLineNumbers;
    };
    return ParagraphSuppressLineNumbersHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphSuppressLineNumbersHistoryItem = ParagraphSuppressLineNumbersHistoryItem;
var ParagraphWidowOrphanControlHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphWidowOrphanControlHistoryItem, _super);
    function ParagraphWidowOrphanControlHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphWidowOrphanControlHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.widowOrphanControl;
    };
    return ParagraphWidowOrphanControlHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphWidowOrphanControlHistoryItem = ParagraphWidowOrphanControlHistoryItem;
var ParagraphDivIdHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphDivIdHistoryItem, _super);
    function ParagraphDivIdHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphDivIdHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.divId;
    };
    return ParagraphDivIdHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphDivIdHistoryItem = ParagraphDivIdHistoryItem;
var ParagraphKeepWithNextHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphKeepWithNextHistoryItem, _super);
    function ParagraphKeepWithNextHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphKeepWithNextHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.paragraphProperties.keepWithNext;
    };
    return ParagraphKeepWithNextHistoryItem;
}(ParagraphPropertiesHistoryItemBase));
exports.ParagraphKeepWithNextHistoryItem = ParagraphKeepWithNextHistoryItem;
var ParagraphPropertiesHistoryItem = (function (_super) {
    tslib_1.__extends(ParagraphPropertiesHistoryItem, _super);
    function ParagraphPropertiesHistoryItem(modelManipulator, subDocument, paragraphIndex, paragraphProperties, style, numberingListIndex, listLevelIndex, tabs) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.subDocument = subDocument;
        _this.paragraphIndex = paragraphIndex;
        _this.style = style;
        _this.numberingListIndex = numberingListIndex;
        _this.listLevelIndex = listLevelIndex;
        _this.paragraphProperties = paragraphProperties;
        _this.tabs = tabs.clone();
        return _this;
    }
    ParagraphPropertiesHistoryItem.prototype.redo = function () {
        var paragraph = this.subDocument.paragraphs[this.paragraphIndex];
        this.oldParagraphProperties = paragraph.maskedParagraphProperties;
        this.oldStyle = paragraph.paragraphStyle;
        this.oldNumberingListIndex = paragraph.numberingListIndex;
        this.oldListLevelIndex = paragraph.listLevelIndex;
        this.oldTabs = paragraph.tabs.clone();
        this.modelManipulator.paragraphProperties.changeAllProperties(this.subDocument, this.paragraphIndex, this.paragraphProperties, this.style, this.tabs, this.numberingListIndex, this.listLevelIndex);
    };
    ParagraphPropertiesHistoryItem.prototype.undo = function () {
        this.modelManipulator.paragraphProperties.changeAllProperties(this.subDocument, this.paragraphIndex, this.oldParagraphProperties, this.oldStyle, this.oldTabs, this.oldNumberingListIndex, this.oldListLevelIndex);
    };
    return ParagraphPropertiesHistoryItem;
}(history_item_1.HistoryItem));
exports.ParagraphPropertiesHistoryItem = ParagraphPropertiesHistoryItem;
